
import React, { useEffect, useState } from 'react';
import { COLORS } from '../constants';

interface LoadingScreenProps {
  onFinished: () => void;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ onFinished }) => {
  const [fade, setFade] = useState(false);

  useEffect(() => {
    const criticalImages = [
      'https://i.imgur.com/7WMSVKv.png', 
      'https://i.imgur.com/hHqITQA.png',
      'https://i.imgur.com/ujIljAH.jpeg' 
    ];

    const loadImages = async () => {
      const promises = criticalImages.map(src => {
        return new Promise((resolve) => {
          const img = new Image();
          img.src = src;
          img.onload = resolve;
          img.onerror = resolve; 
        });
      });

      await Promise.race([
        Promise.all(promises),
        new Promise(r => setTimeout(r, 2000))
      ]);

      setFade(true);
      setTimeout(onFinished, 500); 
    };

    loadImages();
  }, [onFinished]);

  return (
    <div className={`fixed inset-0 z-[9999] bg-white flex flex-col items-center justify-center transition-opacity duration-500 ease-in-out ${fade ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}>
      <div className="relative mb-8">
        <svg className="w-20 h-20" viewBox="0 0 24 24" fill="none" style={{ color: COLORS.novusGreen }}>
          <path d="M12 21L11.2 11H12.8L12 21Z" fill="currentColor" opacity="0.15" />
          <path d="M12 21V11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <g style={{ animation: 'spin-fast 1.5s linear infinite', transformOrigin: '12px 11px' }}>
            <circle cx="12" cy="11" r="1.2" fill="currentColor" />
            <path d="M12 11C12 11 12.4 9.5 14.5 6C15.8 3.5 14.8 2.5 13.5 2.5C12.2 2.5 12 11 12 11Z" fill="currentColor" />
            <path d="M12 11C12 11 12.4 9.5 14.5 6C15.8 3.5 14.8 2.5 13.5 2.5C12.2 2.5 12 11 12 11Z" fill="currentColor" transform="rotate(120 12 11)" />
            <path d="M12 11C12 11 12.4 9.5 14.5 6C15.8 3.5 14.8 2.5 13.5 2.5C12.2 2.5 12 11 12 11Z" fill="currentColor" transform="rotate(240 12 11)" />
          </g>
        </svg>
      </div>
      
      <div className="flex flex-col items-center gap-3">
        <h2 className="text-2xl font-black tracking-tighter text-[#1E1E1E]">Novus Energy</h2>
        <div className="w-16 h-0.5 bg-gray-100 rounded-full overflow-hidden relative">
          <div className="absolute inset-0 bg-emerald-500 animate-[loading-bar_1.5s_infinite_ease-in-out]"></div>
        </div>
      </div>

      <style>{`
        @keyframes spin-fast { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes loading-bar { 
          0% { transform: translateX(-100%); width: 30%; } 
          50% { transform: translateX(100%); width: 60%; } 
          100% { transform: translateX(200%); width: 30%; } 
        }
      `}</style>
    </div>
  );
};

export default LoadingScreen;
